import { Component, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/shared/utils.service';
import { FormGroup, FormControl } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { Product } from 'src/app/shared/product.model';
import { AuthService } from 'src/app/auth/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DataService } from 'src/app/shared/data.service';
import { MatDialog } from '@angular/material/dialog';
import { AddProductComponent } from './add-product/add-product.component';
import { User } from 'src/app/auth/user.model';
import { RequestedProductDetailsComponent } from './requested-product-details/requested-product-details.component';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { ExportService } from '../../shared/export.service';

@Component({
    selector: 'app-products',
    templateUrl: './products.component.html',
    styleUrls: ['./products.component.scss'],
    standalone: false
})
export class ProductsComponent implements OnInit {
  showSearch: boolean;
  pageEvent!: PageEvent;
  searchForm!: FormGroup;
  pageSize = 10;
  pageNumber = 1;
  userID: any;
  productsList = new Array<any>();
  queryParams: {
    pageNumber: number;
    pageSize: number;
    searchValue: string | null;
    approved: boolean | null;
    requested: boolean| null;
  } = {
    pageNumber: 0,
    pageSize: 0,
    searchValue: null,
    approved: null,
    requested: null
  };

  searchValue = "";
  totalSize = 0;
  selected = 'approved';
  approved = null;
  requested = null;
  user: User;

  constructor(public utils: UtilsService, 
              private authService: AuthService,
              private router: Router, 
              private dataService: DataService,
              private route: ActivatedRoute, 
              public dialog: MatDialog,
              private exportService: ExportService
          ) {
    this.showSearch = false;
    this.approved = true;
    this.user = this.authService.getUserData();
    this.userID = this.user.id;
    this.route.queryParams.subscribe((params: Params) => {
      if (!this.isEmpty(params)) {
        this.pageNumber = params.pageNumber ? params.pageNumber : 1;
        this.pageSize = params.pageSize ? params.pageSize : 10;
        this.searchValue =  params.searchValue ? params.searchValue : "";
        this.approved = params.approved;
        this.requested = params.requested;
        if (params.requested === 'true') {
          this.selected = 'requested';
        } else {
          this.selected = params.approved === 'true'  ? 'approved'  : 'pending';
          if  (params.approved === undefined) {
            this.approved = true;
            this.selected = 'approved';
          }
        }
      }
      if (this.approved === true || this.approved === 'true') {
        if (this.user.type === utils.userTypes.Manufacturer || this.user.type === utils.userTypes.ManufacturerChild) {
          if (this.requested === true || this.requested === 'true') {
            this.getRequestedProductsFromManufacturer();
          } else {
            this.getProducts();
          }
        } else {
          if (this.requested === true || this.requested === 'true') {
            this.getRequestedProductsFromManufacturer();
          } else {
            this.getDistributorProducts();
          }
        }
      } else {
        if (this.requested === true || this.requested === 'true') {
          this.getRequestedProductsFromManufacturer();
        } else {
          this.getRequestedProducts();
        }
      }
    });
   }

  ngOnInit(): void {
    this.utils.setTitle('Products');
    this.utils.screenTitle.emit({firstTitle: 'Products', firstRoute: '/products'});
    this.searchForm = new FormGroup({
      search: new FormControl(this.searchValue),
    });

    if (this.searchValue) {
      this.showSearch = true;
    }

    this.searchForm.get('search')?.valueChanges.subscribe(value => {
      const newValue = (value || '').trim();
      if (newValue === '' && this.searchValue !== '') {
        setTimeout(() => this.clearSearch(), 0);
      }
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.productsList, event.previousIndex, event.currentIndex);
    let orderedArray = [];
    for (let index = 0; index < this.productsList.length; index++) {
      const element = this.productsList[index];
      orderedArray.push({productId: element.id, orderNumber: index})
    }
    const payload = {
      pageSize: parseInt(this.pageSize.toString(), 10),
      pageNumber: parseInt(this.pageNumber.toString(), 10),
      orderProduct: orderedArray
    };
    this.dataService.post('product/ProductOrdering', payload).then();
  }

  isEmpty(obj: any) {
    return Object.keys(obj).length === 0;
  }

  handlePage(e: any) {
    this.pageNumber = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, approved: this.approved, requested: this.requested};
    this.router.navigate(['/products'], { queryParams: this.queryParams });
  }

  handleSearchClick() {
    if (this.showSearch && this.productsList.length > 0) {
      this.doSearch();
    } else {
      this.showSearch = true;
    }
  }

  doSearch() {
    let searchInput = this.searchForm.get('search')?.value || '';
    this.searchValue = searchInput.trim();
    this.searchForm.get('search')?.setValue(this.searchValue, { emitEvent: false });
    
    if (this.searchValue) {
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, approved: this.approved, requested: this.requested};
      this.router.navigate(['/products'], { queryParams: this.queryParams });
    }
  }

  filterChange(value: any) {
    this.selected = value;
    if (value === 'pending') {
      this.approved = false;
      this.requested = null;
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, approved: this.approved, requested: this.requested};
      this.router.navigate(['/products'], { queryParams: this.queryParams });
    } else if (value === 'approved') {
      this.approved = true;
      this.requested = null;
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, approved: this.approved, requested: this.requested};
      this.router.navigate(['/products'], { queryParams: this.queryParams });
    } else if (value === 'requested') {
      this.requested = true;
      this.approved = null;
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, approved: this.approved, requested: this.requested};
      this.router.navigate(['/products'], { queryParams: this.queryParams });
    }
  }

  openProductDetails(product: any) {
    const dialogRef = this.dialog.open(RequestedProductDetailsComponent, {disableClose: true, width: '600px', data: {product}});
    dialogRef.afterClosed().subscribe((actionTaken) => {
        this.getRequestedProducts();
    });
  }

  clearSearch() {
    this.showSearch = !this.showSearch;
    this.searchForm.get('search')?.setValue('');
    this.searchValue = '';
    this.pageNumber = 1;
    this.queryParams = {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      searchValue: this.searchValue,
      approved: this.approved, 
      requested: this.requested
    };
    this.router.navigate(['/products'], { queryParams: this.queryParams });
  }

  goToProduct(id: any, name: any) {
    this.router.navigate(['/products/product/' + id + '/' + name]);
  }

  openProduct(id: any, name: any, product: any) {
    if (this.selected === 'pending') {
      this.openProductDetails(product);
    } else if (this.selected === 'approved') {
      this.router.navigate(['/products/product/' + id + '/' + name]);
    } else {

    }
  }

  userType() {
    return this.authService.getUserData().type;
  }

  onImgError(event: any) {
    this.utils.theme$.subscribe((isDark: any) => {
      event.target.src  = isDark
        ? '../../../assets/images/products-dark.png'
        : '../../../assets/images/products-light.png';
    });
  }

  approve(product: any, index: any) {
    // Approve request
    this.productsList.splice(index, 1);
    this.openAddProduct(product);
  }

  reject(product: any, index: any) {
    // Reject request
    this.productsList.splice(index, 1);
  }

  openAddProduct(product: any) {
    const dialogRef = this.dialog.open(AddProductComponent, {disableClose: true, width: '400px', data: {product}});
    dialogRef.afterClosed().subscribe((newProduct) => {
      if (newProduct && this.selected === 'approved') {
        this.productsList.unshift(newProduct);
        this.totalSize = this.totalSize + 1;
        if (this.productsList.length <= this.pageSize) {
        } else {
          this.productsList.splice(this.productsList.length - 1, 1);
        }
      }
    });
  }

  getProducts() {
    this.dataService.get('product/RetrieveallProducts/' +
    parseInt(this.userID.toString(), 10) + '?pageNumber=' + this.pageNumber +
    '&pageSize=' + this.pageSize +
    '&searchKeyword=' + this.searchValue +
    '&isApproved=' + this.approved).then((data: any) => {
      if (data.statusCode === 200) {
        this.productsList = [];
        const productsData = data.data.records;
        this.totalSize = data.data.count;
        productsData.forEach((productData: any) => {
          const productInstance = new Product(productData);
          this.productsList.push(productInstance);
        });
        if (productsData.length === 0 && this.totalSize > 0) {
          this.pageNumber = 1;
          this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, approved: this.approved, requested: this.requested};
          this.router.navigate(['/products'], { queryParams: this.queryParams });
        }
      }
    });
  }

  getDistributorProducts() {
    this.dataService.get('product/RetrieveallProducts/' +
    parseInt(this.userID.toString(), 10) + '?pageNumber=' + this.pageNumber +
    '&pageSize=' + this.pageSize +
    '&searchKeyword=' + this.searchValue +
    '&isApproved=' + this.approved).then((data: any) => {
      if (data.statusCode === 200) {
        this.productsList = [];
        const productsData = data.data.records;
        this.totalSize = data.data.count;
        productsData.forEach((productData: any) => {
          const productInstance = new Product(productData);
          this.productsList.push(productInstance);
        });
        if (productsData.length === 0 && this.totalSize > 0) {
          this.pageNumber = 1;
          this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, approved: this.approved, requested: this.requested};
          this.router.navigate(['/products'], { queryParams: this.queryParams });
        }
      }
    });
  }

  getRequestedProducts() {
    this.dataService.get('ProductAccessRequest/RetrieveProductAccessRequests' + '?pageNumber=' + this.pageNumber +
    '&pageSize=' + this.pageSize +
    '&searchKeyword=' + this.searchValue +
    '&isApproved=' + this.approved).then((data: any) => {
      if (data.statusCode === 200) {
        this.productsList = [];
        const productsData = data.data.records;
        this.totalSize = data.data.count;
        productsData.forEach((productData: any) => {
          this.productsList.push(productData);
        });
        if (productsData.length === 0 && this.totalSize > 0) {
          this.pageNumber = 1;
          this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, approved: this.approved, requested: this.requested};
          this.router.navigate(['/products'], { queryParams: this.queryParams });
        }
      }
    });
  }


  getRequestedProductsFromManufacturer() {
    this.dataService.get('ProductAccessRequest/RetrieveDistributorProductAccessThatRequested' + '?pageNumber=' + this.pageNumber +
    '&pageSize=' + this.pageSize +
    '&searchKeyword=' + this.searchValue).then((data: any) => {
      if (data.statusCode === 200) {
        this.productsList = [];
        const productsData = data.data.records;
        this.totalSize = data.data.count;
        productsData.forEach((productData: any) => {
          this.productsList.push(productData);
        });
        if (productsData.length === 0 && this.totalSize > 0) {
          this.pageNumber = 1;
          this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, approved: this.approved, requested: this.requested};
          this.router.navigate(['/products'], { queryParams: this.queryParams });
        }
      }
    });
  }

  deleteSubscription(id: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '400px',
      data: {
        title: 'Delete',
        page: 'subscription',
      }
    });
    dialogRef.afterClosed().subscribe((status) => {
      if (status) {
        if (status === 'accept') {
          this.dataService.delete('ProductAccessRequest/DeleteProductAccessRequest/' + id).then((data: any) => {
            if (data.statusCode === 200) {
              this.productsList.forEach( (products, index) => {
                if (products.id === id) {
                  this.productsList.splice(index, 1);
                  if (this.productsList.length === 0 && this.pageNumber > 1) {
                    this.pageNumber = this.pageNumber - 1;
                    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue, approved: this.approved, requested: this.requested};
                    this.router.navigate(['/products'], { queryParams: this.queryParams });
                  } else {
                    this.getRequestedProducts();
                  }
                }
              });
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Success',
                  type: 'Success',
                  message: 'Subscription deleted successfully',
                  buttonText: 'Ok'
                }
              });
            } else {
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Error',
                  type: 'Error',
                  message: 'Something went wrong, Please try again!',
                  buttonText: 'Ok'
                }
              });
            }
          });
        }
      }
    });
  }

  exportProducts(fileTypeId: number) {
    this.exportService.exportFile(`product/ExportAllProducts/${this.userID}`, fileTypeId, this.searchValue, 'products', { isApproved: this.approved } );
  }

}
